<script setup>
const emit = defineEmits(['add']);

const addLabel = () => {
  emit('add');
};
</script>

<template>
  <!-- SiteUp Contatos: etiquetas #4 ícone-mais — círculo + rótulo curto, inline no fluxo de pills. -->
  <button
    type="button"
    class="mb-0.5 inline-flex h-6 items-center gap-1.5 ltr:mr-0.5 rtl:ml-0.5"
    @click="addLabel"
  >
    <span
      class="inline-flex size-6 shrink-0 items-center justify-center rounded-full border border-n-strong bg-n-alpha-2 text-n-blue-11 transition-colors hover:bg-n-alpha-3 hover:text-n-blue-12"
      aria-hidden="true"
    >
      <span class="i-ri-add-line size-3.5" />
    </span>
    <span class="text-xs font-normal text-n-slate-11">
      {{ $t('CONTACT_PANEL.LABELS.CONVERSATION.ADD_BUTTON') }}
    </span>
  </button>
</template>
